module.exports = __webpack_public_path__ + "assets/img/step5-title.517682b1.svg";